import React from 'react';
import { useAssistant } from '../../hooks/useAssistant';
import {
  AlertTriangle,
  Activity,
  Sparkles,
  RefreshCw
} from 'lucide-react';

const EurekaInsights = () => {
  const { kpis, informe, recomendaciones, loading, actualizarDatos } = useAssistant();

  if (loading) {
    return (
      <div className="bg-white rounded-lg shadow-card border border-gray-200 p-6">
        <div className="animate-pulse">
          <div className="h-4 bg-gray-200 rounded w-3/4 mb-4"></div>
          <div className="h-4 bg-gray-200 rounded w-1/2"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-card border border-gray-200 p-6">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="bg-primary-700 p-2 rounded-lg">
            <Sparkles className="h-6 w-6 text-white" />
          </div>
          <div>
            <h3 className="text-xl font-semibold text-gray-900 flex items-center gap-2">
              EUREKA Insights
              <span className="text-xs font-normal text-primary-700 bg-primary-50 px-2 py-1 rounded-full">
                Simulación AI
              </span>
            </h3>
            <p className="text-sm text-gray-500">
              Prototipo – resultados generados con datos simulados
            </p>
          </div>
        </div>
        <button
          onClick={actualizarDatos}
          className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          title="Actualizar datos"
        >
          <RefreshCw className="h-5 w-5 text-gray-600" />
        </button>
      </div>

      <div className="bg-gray-50 rounded-lg p-4 mb-4 border border-gray-200">
        <div className="flex items-center gap-2 mb-3">
          <Activity className="h-5 w-5 text-primary-700" />
          <h4 className="font-semibold text-gray-900">Análisis del Sistema</h4>
        </div>
        <div className="text-sm text-gray-600 whitespace-pre-line leading-relaxed">
          {informe}
        </div>
      </div>

      {kpis && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
          <div className="bg-white rounded-lg p-3 border border-gray-200">
            <div className="text-xs text-gray-500 mb-1">Garantías Activas</div>
            <div className="text-2xl font-bold text-primary-700">
              {kpis.garantiasActivas}
            </div>
            <div className="text-xs text-gray-500">de {kpis.garantiasTotal}</div>
          </div>
          <div className="bg-white rounded-lg p-3 border border-gray-200">
            <div className="text-xs text-gray-500 mb-1">Averías Pendientes</div>
            <div className="text-2xl font-bold text-orange-600">
              {kpis.averiasPendientes}
            </div>
            <div className="text-xs text-gray-500">de {kpis.averiasTotal}</div>
          </div>
          <div className="bg-white rounded-lg p-3 border border-gray-200">
            <div className="text-xs text-gray-500 mb-1">Facturación Mes</div>
            <div className="text-2xl font-bold text-green-600">
              {kpis.facturacionMes}€
            </div>
            <div className="text-xs text-gray-500">+{kpis.crecimiento}%</div>
          </div>
          <div className="bg-white rounded-lg p-3 border border-gray-200">
            <div className="text-xs text-gray-500 mb-1">Satisfacción</div>
            <div className="text-2xl font-bold text-blue-600">
              {kpis.satisfaccionPromedio}%
            </div>
            <div className="text-xs text-gray-500">promedio</div>
          </div>
        </div>
      )}

      {recomendaciones && recomendaciones.length > 0 && (
        <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
          <div className="flex items-center gap-2 mb-3">
            <AlertTriangle className="h-5 w-5 text-orange-600" />
            <h4 className="font-semibold text-gray-900">Recomendaciones</h4>
          </div>
          <div className="space-y-2">
            {recomendaciones.map((rec, index) => (
              <div
                key={index}
                className={`p-3 rounded-lg border-l-4 ${
                  rec.prioridad === 'alta'
                    ? 'bg-red-50 border-red-500'
                    : rec.prioridad === 'media'
                    ? 'bg-orange-50 border-orange-500'
                    : 'bg-blue-50 border-blue-500'
                }`}
              >
                <div className="flex items-start gap-2">
                  <span
                    className={`text-xs font-semibold px-2 py-1 rounded ${
                      rec.prioridad === 'alta'
                        ? 'bg-red-100 text-red-700'
                        : rec.prioridad === 'media'
                        ? 'bg-orange-100 text-orange-700'
                        : 'bg-blue-100 text-blue-700'
                    }`}
                  >
                    {rec.prioridad.toUpperCase()}
                  </span>
                  <div className="flex-1">
                    <p className="text-sm font-medium text-gray-900">{rec.titulo}</p>
                    <p className="text-xs text-gray-600 mt-1">{rec.descripcion}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="mt-4 text-xs text-center text-gray-500">
        Resultados simulados – prototipo sin IA real
      </div>
    </div>
  );
};

export default EurekaInsights;
